import { TrackingEvent } from '../types/tracking.types.ts';
import { getAppBuildUtil } from '../utils/app-build.util.ts';
import { getUrlUtil } from '../utils/url.util.ts';

export const mapTrackingEventAddTestingProperty = (event: TrackingEvent): TrackingEvent => {
  // Only skip adding testing property for production build and production url
  if (getAppBuildUtil().isProductionBuild() && getUrlUtil().isProductionUrl()) {
    return event;
  }

  return {
    ...event,
    data: {
      ...(event.data ?? {}),
      testing: true,
    },
  } as TrackingEvent;
};
